export default "__VITE_ASSET__DyjPisBp__"